import { render } from "./NewPurchase.vue?vue&type=template&id=30cc245a"
import script from "./NewPurchase.vue?vue&type=script&lang=js"
export * from "./NewPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__